import Roles from "@/utils/roles"
import { isInRoles } from "@/utils/authorize.directive"

// The global `meta.roles` check is still commented out in the router, so hiding the
// menu entry alone would leave the URL reachable by typing it.
const requireVeiculosGerenciar = (to, from, next) => {
    if (!isInRoles(Roles.VeiculosGerenciar)) {
        next({ name: 'home' })
        return
    }
    next()
}

export default [
    {
        path: "/veiculos",
        name: "veiculos",
        component: () => import("@/views/area-mention/veiculos/index.vue"),
        meta: {
          title: 'Veiculos',
          authRequired: true,
          roles: [Roles.VeiculosGerenciar]
        },
        beforeEnter: requireVeiculosGerenciar,
    },
    {
      path: "/veiculos/:id",
      name: "veiculos-view",
      component: () => import("@/views/area-mention/veiculos/form.vue"),
      meta: {
        title: 'Veiculos',
        authRequired: true,
        roles: [Roles.VeiculosGerenciar]
      },
      beforeEnter: requireVeiculosGerenciar,
  },
];
